import l from "../util/net.js";
import r from "../managers/braze-instance.js";
import ControlMessage from "./models/control-message.js";
import HtmlMessage from "./models/html-message.js";
import InAppMessage from "./models/in-app-message.js";
import InAppMessageButton from "./models/in-app-message-button.js";
import v from "../common/event-logger.js";
import { newInAppMessageFromJson as ut } from "./in-app-message-factory.js";
import { randomInclusive as a } from "../util/math.js";
import H from "../models/request-result.js";
import { logger as E, EventTypes as f } from "../../shared-lib/index.js";
import m from "../managers/subscription-manager.js";
import pt from "../triggers/models/trigger.js";
import { BRAZE_ACTION_URI_REGEX as to } from "../util/validation-utils.js";
import {
  containsPushPrimerBrazeAction as ft,
  containsUnknownBrazeAction as gt,
  getDecodedBrazeAction as eo,
  ineligibleBrazeActionURLErrorMessage as dt,
  INELIGIBLE_BRAZE_ACTION_URL_ERROR_TYPES as jt,
} from "../util/braze-actions.js";
import vt from "../Push/utils/push-utils.js";
import h from "../util/request-header-utils.js";
import { STORAGE_KEYS as s } from "../managers/storage-manager.js";
import { FullScreenMessage, ModalMessage, SlideUpMessage } from "./index.js";
export default class ea {
  constructor(t, e, s, i) {
    (this.j = t),
      (this.C = e),
      (this.B = s),
      (this.vs = i),
      (this.j = t),
      (this.C = e),
      (this.B = s),
      (this.vs = i),
      (this.jn = new m()),
      r.q(this.jn),
      (this.vn = 1e3),
      (this.yn = 6e4),
      (this.bn = null),
      (this.In = null),
      (this.Mn = null);
  }
  An() {
    return this.jn;
  }
  Tn(t) {
    return this.jn.Rt(t);
  }
  kn() {
    return this.bn;
  }
  Dn(t) {
    this.bn = t;
  }
  lt(t, e, s, i) {
    const r = new H();
    let n;
    if (e === f.wn || t instanceof ControlMessage) {
      if (!t.Wt())
        return (
          E.info(
            "This in-app message has already received an impression. Ignoring analytics event.",
          ),
          r
        );
    } else if (e === f.zn || (t instanceof HtmlMessage && e === f.Sn)) {
      if (!t.$t(i))
        return (
          E.info(
            "This in-app message has already received a click. Ignoring analytics event.",
          ),
          r
        );
    }
    return (
      (n =
        t instanceof ControlMessage
          ? { trigger_ids: [t.triggerId] }
          : this.Bn(t)),
      null == n
        ? r
        : (t.messageExtras && (n.message_extras = t.messageExtras),
          null != s && (n.bid = s),
          v.lt(e, n))
    );
  }
  Rn(t, e) {
    const s = new H();
    if (!t.$t())
      return (
        E.info(
          "This in-app message button has already received a click. Ignoring analytics event.",
        ),
        s
      );
    const i = this.Bn(e);
    return null == i
      ? s
      : t.id === InAppMessageButton._n
      ? (E.info(
          "This in-app message button does not have a tracking id. Not logging event to Braze servers.",
        ),
        s)
      : (null != t.id && (i.bid = t.id), v.lt(f.Sn, i));
  }
  qn(t) {
    const e = t.messageFields;
    return (null != e && e.is_push_primer) || !1;
  }
  xn(t) {
    if (!(t instanceof InAppMessage)) return;
    const e = (t) => {
      if (!t) return;
      const e = eo(t);
      if (gt(e)) return dt(jt.Pn, "In-App Message");
      if (ft(e)) {
        const t = vt.En();
        if (!t.Gn) return vt.Nn(t.reason, "In-App Message");
      }
    };
    if (this.qn(t)) {
      const t = vt.En();
      if (!t.Gn) return vt.Nn(t.reason, "In-App Message");
    }
    const s = t.buttons || [];
    let i;
    for (const t of s)
      if (
        t.clickAction === InAppMessage.ClickAction.URI &&
        t.uri &&
        to.test(t.uri) &&
        ((i = e(t.uri)), i)
      )
        return i;
    return t.clickAction === InAppMessage.ClickAction.URI &&
      t.uri &&
      to.test(t.uri)
      ? e(t.uri)
      : void 0;
  }
  $n(t, e) {
    e !== this.Mn && this.Cn(), (this.In = t), (this.Mn = e);
  }
  Cn() {
    null != this.In &&
      (clearTimeout(this.In), (this.In = null), (this.Mn = null));
  }
  Fn(t, e, s, i) {
    const r = this.j;
    if (!r) return;
    this.Mn && t.triggerId !== this.Mn && (this.Cn(), h.fi(this.B, h.H.On));
    const n = r.Xn(!1),
      o = r.$(n);
    (o.template = { trigger_id: t.triggerId, trigger_event_type: e }),
      null != s && (o.template.data = s.Hn());
    const u = r.A(o, h.H.On);
    r.J(
      o,
      (r = -1) => {
        const n = this.j;
        if (!n) return;
        const m = new Date().valueOf();
        h.K(this.B, h.H.On, m),
          -1 !== r && u.push(["X-Braze-Req-Tokens-Remaining", r.toString()]);
        let c,
          p,
          f = !1;
        l.O({
          url: `${n.V()}/template/`,
          data: o,
          headers: u,
          W: (e) => {
            if (!n.Y(o, e, u))
              return void ("function" == typeof t.Jn && t.Jn());
            if ((n.Z(), null == e || null == e.templated_message)) return;
            const s = e.templated_message;
            if (s.type !== pt.Ln.Kn) return;
            const i = ut(s.data);
            if (null == i) return;
            const r = this.xn(i);
            if (r)
              return E.error(r), void ("function" == typeof t.Jn && t.Jn());
            "function" == typeof t.Qn && t.Qn(i);
          },
          error: (e) => {
            (f = !0),
              (c = e),
              (p = `getting user personalization for message ${t.triggerId}.`);
          },
          tt: (r, o) => {
            if (new Date().valueOf() - t.Un < t.Vn) {
              let r = 0;
              if (f) {
                const e = Math.min(t.Vn, this.yn),
                  s = this.vn;
                null == i && (i = s), (r = Math.min(e, a(s, 3 * i)));
              }
              n.et(
                o,
                () => {
                  this.Fn(t, e, s, r);
                },
                h.H.On,
                (e) => this.$n(e, t.triggerId),
                () => this.Cn(),
                r,
              );
            }
            f && n._(c, p);
          },
        });
      },
      h.H.On,
    );
  }
  Bn(t) {
    if (null == t.triggerId)
      return (
        E.info(
          "The in-app message has no analytics id. Not logging event to Braze servers.",
        ),
        null
      );
    const e = {};
    return null != t.triggerId && (e.trigger_ids = [t.triggerId]), e;
  }
  fn(t) {
    return (
      !!this.B &&
      !(
        !(t && t instanceof InAppMessage && t.constructor !== InAppMessage) ||
        t instanceof ControlMessage
      ) &&
      this.B.bt(s.ft.Wn, t.gt())
    );
  }
  sa() {
    if (!this.B) return null;
    const t = this.B.dt(s.ft.Wn);
    if (!t) return null;
    let e;
    switch (t.type) {
      case InAppMessage.Eo.Yn:
        e = FullScreenMessage.Zn(t);
        break;
      case InAppMessage.Eo.Zo:
      case InAppMessage.Eo.Bo:
      case InAppMessage.Eo.Yo:
        e = HtmlMessage.Zn(t);
        break;
      case InAppMessage.Eo.ta:
      case InAppMessage.Eo.Xo:
        e = ModalMessage.Zn(t);
        break;
      case InAppMessage.Eo.ia:
        e = SlideUpMessage.Zn(t);
    }
    return e && this.oa(), e;
  }
  oa() {
    this.B && this.B.zt(s.ft.Wn);
  }
}
